/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Provider as ClientProvider,
  JsonValue,
  OpenFeatureEventEmitter,
  ProviderEvents,
  ResolutionDetails,
} from "@openfeature/react-sdk";

/**
 * A no-operation web provider that returns default values for all flag evaluations.
 * This provider is used when NEXT_PUBLIC_UNLEASH_URL is not provided.
 */
export class NoopWebProvider implements ClientProvider {
  metadata = {
    name: NoopWebProvider.name,
  };

  public readonly events = new OpenFeatureEventEmitter();

  readonly runsOn = "client";

  hooks = [];

  async initialize(): Promise<void> {
    this.events.emit(ProviderEvents.Ready, {
      message: "Ready",
    });
  }

  async onContextChange(): Promise<void> {
    // No-op
  }

  async onClose() {
    // No-op
  }

  resolveBooleanEvaluation(_flagKey: string, defaultValue: boolean): ResolutionDetails<boolean> {
    return {
      value: true,
    };
  }

  resolveStringEvaluation(_flagKey: string, defaultValue: string): ResolutionDetails<string> {
    return {
      value: defaultValue,
    };
  }

  resolveNumberEvaluation(_flagKey: string, defaultValue: number): ResolutionDetails<number> {
    return {
      value: defaultValue,
    };
  }

  resolveObjectEvaluation<T extends JsonValue>(_flagKey: string, defaultValue: T): ResolutionDetails<T> {
    return {
      value: defaultValue,
    };
  }
}
